// Tracks how many floating buttons (WhatsApp, "View Enquiry") a page shows in the
// bottom-right corner so the global chatbot bubble can stack above them.
// The current value is kept here as well as broadcast, so a listener that mounts
// after a page has already set its stack (e.g. on a direct page load) still sees it.
export const FLOATING_STACK_EVENT = "enquiry-fab-visibility";

let current = 0;

export function getFloatingStack() {
  return current;
}

export function setFloatingStack(stack) {
  current = stack;
  window.dispatchEvent(new CustomEvent(FLOATING_STACK_EVENT, { detail: { visible: stack > 0, stack } }));
}
